import { render, staticRenderFns } from "./forms-and-status.vue?vue&type=template&id=27d737f2&scoped=true&"
import script from "./forms-and-status.vue?vue&type=script&lang=js&"
export * from "./forms-and-status.vue?vue&type=script&lang=js&"
import style0 from "./forms-and-status.vue?vue&type=style&index=0&id=27d737f2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d737f2",
  null
  
)

export default component.exports